import { Component, OnInit, Input } from '@angular/core';
import { ICommandColumnOptions, ICommandColumnAction } from '../../models';

@Component({
  selector: 'ps-command-data-grid-column',
  templateUrl: './command-data-grid-column.component.html',
  styleUrls: ['./command-data-grid-column.component.css']
})
export class CommandDataGridColumnComponent implements OnInit {

  @Input() column: ICommandColumnOptions;
  @Input() model: any;

  constructor() { 
  }

  ngOnInit() {
  }

  buttonClasses(a: ICommandColumnAction) {
    return `ui button ${(a.buttonClass ? a.buttonClass : '')}`;
  }

  emitAction(a: ICommandColumnAction) {
    a.callback(this.model);
  }
}
